module.exports = __webpack_public_path__ + "img/home-popup-top2.92cf0f4b.png";